import {load_products} from "./product-catalog";

(function ($) {

	function init_product_catalog_load_more_button() {
		$('#pagination-load-more').off('click').click(function (e) {
			e.preventDefault()
			load_products($(this).attr('href'), true)
		})
	}

	$(document).gp_ready(init_product_catalog_load_more_button)

})(jQuery);